import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    searchParams: {
        id: "",
        supplier: null,
        date: "",
    },
    page: pageModel
}

const purchaseSlice = createSlice({
    name: 'purchase',
    initialState,
    reducers: {
        setPurchasePageAction: (state, action) => {
            state.page = action.payload
        },
        getPurchasePageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addPurchaseAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updatePurchaseAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deletePurchaseAction: (state, action) => {
            const content = state.page.content.filter(x => x.id !== action.payload)
            state.page.content = content
        },
        uploadPurchaseExcelFileAction: (state, action) => {
            let content = [...action.payload.reverse(), ...state.page.content]
            state.page.content = content
            // state.page.content = content
        },
        setPurchaseSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.searchParams = { ...state.searchParams, [key]: value }
        }
    },
});

export const { setPurchaseSearchParamsAction, setPurchasePageAction, getPurchasePageAction, addPurchaseAction, updatePurchaseAction, deletePurchaseAction, uploadPurchaseExcelFileAction } = purchaseSlice.actions;
export default purchaseSlice;